import * as React from 'react'
import { iframeResizer } from 'iframe-resizer'
import i18next from 'i18next'
import { pushIframeEvent } from '../../seo/datalayer.consent'

export type IframeProps = {
  url: string
}

type IframeState = {
  status: 'loading' | 'done'
}

export class Iframe extends React.Component<IframeProps, IframeState> {
  private iframe: React.RefObject<HTMLIFrameElement> | null = null
  private resizedIframe: React.RefObject<HTMLIFrameElement> | null = null

  private handleMessage = (event: MessageEvent) => {
    if (event.origin !== 'https://reuma-nl.fly.dev') return
    let data: unknown = event.data

    if (typeof data === 'string') {
      try { data = JSON.parse(data) }
      catch { return }
    }

    if (typeof data === 'object' && data !== null && 'type' in data && (data as any).type === 'gtag_event') {
      const d = data as any
      pushIframeEvent(d.eventName, d.eventData)
    }
  }

  constructor(props: IframeProps) {
    super(props)

    this.iframe = React.createRef()
    this.resizedIframe = React.createRef()

    this.state = {
      status: 'loading'
    }

    this.handleIFrameLoad = this.handleIFrameLoad.bind(this)
    this.handleIFrameResize = this.handleIFrameResize.bind(this)
  }

  componentDidMount() {
    this.handleIFrameResize()
    window.addEventListener('resize', this.handleIFrameResize)
    window.addEventListener('message', this.handleMessage)

    if (this.resizedIframe?.current) {
      (iframeResizer as any)({
        onResized: ({ iframe }: { iframe: HTMLIFrameElement }) => {
          iframe.classList.add('show')
        }
      }, this.resizedIframe.current)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleIFrameResize)
    window.removeEventListener('message', this.handleMessage)

    if (this.resizedIframe?.current && (this.resizedIframe.current as any).iFrameResizer) {
      (this.resizedIframe.current as any).iFrameResizer.close()
    }
  }

  private getProcessedIframeUrl(): string {
    let iframeUrl = this.props.url || ''
    const searchParams = new URLSearchParams(window.location.search)
    const dtq = searchParams.get('dtq')

    if (iframeUrl.includes('e.reumanederland.nl') && dtq) {
      try {
        const url = new URL(iframeUrl)
        url.searchParams.set('dtq', dtq)
        iframeUrl = url.toString()
      } catch {
        const separator = iframeUrl.includes('?') ? '&' : '?'
        iframeUrl = `${iframeUrl}${separator}dtq=${encodeURIComponent(dtq)}`
      }
    }

    return iframeUrl
  }

  handleIFrameResize() {
    if (this.iframe && this.iframe.current?.classList.contains('iframe-unresized')) {
      const iframe = this.iframe.current

      if(iframe.src.includes('anbigift')) {
        const windowSize = window.innerWidth

        if(windowSize <= 480) {
          iframe.height = '940px'
        } else if(windowSize > 480 && windowSize <= 640) {
          iframe.height = '840px'
        } else if(windowSize > 640 && windowSize <= 1060) {
          iframe.height = '650px'
        } else if(windowSize > 1060 && windowSize <= 1200) {
          iframe.height = '500px'
        } else {
          iframe.height = '480px'
        }
      }
    }
  }

  handleIFrameLoad() {
    this.setState((s) => ({ ...s, status: 'done' }))
  }

  render() {
    const processedUrl = this.getProcessedIframeUrl()

    return (
      <>
        {this.props.url != '' && this.state.status === 'loading' && (
          <p className='iframe-loading'>{i18next.t('General:IframeLoading')}</p>
        )}

        {this.props.url.includes('anbigift') ? (
          <iframe
            ref={this.iframe}
            id="iframe-unresized"
            className='iframe-unresized show'
            style={{ width: '1px', minWidth: '100%', minHeight: '480px' }}
            src={this.props.url != '' ? this.props.url : ''}
            loading='lazy'
            onLoad={this.handleIFrameLoad}
          />
        ) : (
          <iframe
            ref={this.resizedIframe}
            id="iframe-resized"
            className='iframe'
            style={{ width: '1px', minWidth: '100%'}}
            src={processedUrl}
            loading='lazy'
            onLoad={this.handleIFrameLoad}
          />
        )}
      </>
    )
  }
}
